import { useState } from "react";
import { StringNumber } from "../../../../types";
import api from "../../../../utils/api";
import { useErrorSuccess } from "../../../../hooks/useErrorSuccess";
import { T_Evento } from "../../../../components/selects/celula";


export type ResponseServiceEdit = {
  celula: T_Evento|undefined;
  cadastrarCelula: VoidFunction;
  changeCampusCelula: (campo: keyof (T_Evento & {sede: StringNumber, ministerio: StringNumber}), valor: any | null) => void;
  valuesExtras: {
    ministerio: number,
    sede: number
  },
  isError: T_Evento
};

export const ServicesCadastrar = (): ResponseServiceEdit => {
  const [celula, setCelula] = useState<T_Evento>();

  const [ministerio, setMinisterio] = useState<number>();
  const [sede, setSede] = useState<number>();
  const [isError, setErrorActive] = useState<T_Evento>();

  const { setErrorSuccess } = useErrorSuccess();

  const cadastrarCelula = async () => {
    try {
      const req = await api.post('ministerio/celula', celula);
      const res = req?.data;

      setErrorSuccess({ mensagem: 'Celula Atualizada', status: 'success' })
    } catch(error) {
      if(!error?.response?.data?.mensagem) {
        if(!celula?.cep) {
          setErrorActive((value) => ({...value, cep: 'cep não passado!'}));
        }
        if(!celula?.inicio) {
          setErrorActive((value) => ({...value, inicio: 'Data inicío não passado!'}));
        }
        if(!celula?.fim) {
          setErrorActive((value) => ({...value, fim: 'Data Fim não passado!'}));
        }
        if(!celula?.bairro) {
          setErrorActive((value) => ({...value, bairro: 'Bairro não passado!'}));
        }
        if(!celula?.rua) {
          setErrorActive((value) => ({...value, rua: 'Rua não passado!'}));
        }
        if(!celula?.descricao) {
          setErrorActive((value) => ({...value, descricao: 'Nome do evento não passado!'}));
        }
        if(!celula?.whatsapp) {
          setErrorActive((value) => ({...value, whatsapp: 'Whatsapp não passado!'}));
        }
        if(!celula?.celula) {
          setErrorActive((value) => ({...value, celula: 'PG não passado!'}));
        }
      };
      setErrorSuccess({ mensagem: JSON.stringify(error?.response?.data?.mensagem, null, 2) || 'Erro ao enviar os dados. Por favor, verifique se os dados estão corretos', status: 'error' })
    }
  };

  const changeCampusCelula = (campo: keyof (T_Evento & {sede: StringNumber, ministerio: StringNumber}), value: any | null) => {

    if(campo == 'sede') {
      setSede(value);
      return;
    }

    if(campo == 'ministerio') {
      setMinisterio(value);
      return;
    }

    setCelula(
      (valor: any) => {
      return { ...valor, [campo]: value }
    }
  )
  }

  return {
    celula,
    valuesExtras: {
      ministerio,
    sede,
    },
    cadastrarCelula,
    changeCampusCelula,
    isError
  }
};
